
module.exports = {
    fundsAvailableForPaymentDaysNumber:{
        trackingNumberSet:11,
        fulfilledAt:4
    },
};
